import script from "./DriverFiltersBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DriverFiltersBar.vue?vue&type=script&setup=true&lang=ts"

import "./DriverFiltersBar.vue?vue&type=style&index=0&id=9474c4a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9474c4a6"]])

export default __exports__